module.exports = __webpack_public_path__ + "img/xiaomi-6.b5838d6a.png";